import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "reorder-title"
};
const _hoisted_2 = {
  key: 1,
  class: "approvers-list",
  "data-test": "approvers-reorder-list"
};
const _hoisted_3 = ["onDragstart", "onDragenter", "onDrop"];
const _hoisted_4 = {
  class: "grab-handle",
  "aria-hidden": "true"
};
const _hoisted_5 = {
  class: "order-badge"
};
const _hoisted_6 = {
  class: "user-line"
};
const _hoisted_7 = {
  class: "user-cell-wrapper"
};
const _hoisted_8 = {
  class: "role-inline"
};
const _hoisted_9 = {
  key: 0,
  class: "role-dot"
};
const _hoisted_10 = ["title"];
const _hoisted_11 = {
  class: "role-popover"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_select_users = _resolveComponent("w-select-users");
  const _component_icon = _resolveComponent("icon");
  const _component_user_cell = _resolveComponent("user-cell");
  const _component_el_input = _resolveComponent("el-input");
  const _component_icon_button = _resolveComponent("icon-button");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_el_popover = _resolveComponent("el-popover");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isPeriodic ? 'periodic-body' : 'anonymous-body')
  }, [_createVNode(_component_w_select_users, {
    class: "selectWithoutTags",
    modelValue: _ctx.approvers,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.approvers = $event),
    multiple: true,
    "role-filter": "APPROVER",
    placeholder: _ctx.$t('workflow.anonymous.placeholder'),
    "data-test": "select-approvers",
    onInput: _ctx.emitChange
  }, null, 8, ["modelValue", "placeholder", "onInput"]), _ctx.approvers.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('workflow.anonymous.reorder')), 1)) : _createCommentVNode("", true), _ctx.approvers.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvers, (user, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: user.id || index,
      class: _normalizeClass(["approver-item", {
        'is-drag-over': index === _ctx.dragOverIndex
      }]),
      draggable: "true",
      onDragstart: $event => _ctx.onDragStart(index),
      onDragenter: _withModifiers($event => _ctx.onDragEnter(index), ["prevent"]),
      onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _withModifiers($event => _ctx.onDrop(index), ["prevent"]),
      onDragend: _cache[3] || (_cache[3] =
      //@ts-ignore
      (...args) => _ctx.onDragEnd && _ctx.onDragEnd(...args))
    }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_icon, {
      icon: "drag-vertical"
    })]), _createElementVNode("div", _hoisted_5, _toDisplayString(index + 1), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_user_cell, {
      user: _ctx.toUser(user),
      "search-term": ""
    }, null, 8, ["user"])]), _createElementVNode("div", _hoisted_8, [user.role ? (_openBlock(), _createElementBlock("span", _hoisted_9, "•")) : _createCommentVNode("", true), user.role ? (_openBlock(), _createElementBlock("span", {
      key: 1,
      class: "role-text",
      title: user.role
    }, _toDisplayString(user.role), 9, _hoisted_10)) : _createCommentVNode("", true)])]), _createVNode(_component_el_popover, {
      ref_for: true,
      ref: _ctx.setPopoverRef(index),
      placement: "right-start",
      trigger: "click",
      width: 300,
      persistent: true,
      onShow: $event => _ctx.onPopoverShow(index)
    }, {
      reference: _withCtx(() => [_createElementVNode("button", {
        class: "edit-role-btn",
        type: "button",
        onClick: $event => _ctx.prepareRoleEditor(user.role || ''),
        "aria-label": "Edit role"
      }, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('workflow.anonymous.roleTooltip')
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "account-edit-outline"
        })]),
        _: 1
      }, 8, ["text"])], 8, _hoisted_12)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_input, {
        ref_for: true,
        ref: _ctx.setRoleInputRef(index),
        modelValue: _ctx.roleEditorValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.roleEditorValue = $event),
        class: "role-input",
        placeholder: _ctx.$t('workflow.anonymous.rolePlaceholder'),
        onKeydown: _withKeys(_withModifiers($event => _ctx.saveRole(index), ["prevent"]), ["enter"])
      }, null, 8, ["modelValue", "placeholder", "onKeydown"]), _createVNode(_component_icon_button, {
        class: _normalizeClass(["save-role-btn", _ctx.roleEditorValue === '' ? 'disabled' : '']),
        icon: "check",
        disabled: _ctx.roleEditorValue === '',
        onClick: $event => _ctx.saveRole(index)
      }, null, 8, ["class", "disabled", "onClick"])])]),
      _: 2
    }, 1032, ["onShow"]), _createElementVNode("button", {
      class: "trash-btn",
      type: "button",
      "aria-label": "Remove approver",
      onClick: $event => _ctx.removeApprover(index)
    }, [_createVNode(_component_w_tool_tip, {
      text: _ctx.$t('workflow.anonymous.removeApproverTooltip')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "delete-outline"
      })]),
      _: 1
    }, 8, ["text"])], 8, _hoisted_13)], 42, _hoisted_3);
  }), 128))])) : _createCommentVNode("", true)], 2);
}